import { Card, Flex, Spacer } from '@zillow/constellation';
import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

import { PAYMENT_DESCRIPTION_TO_TYPE } from '../../../../constants/PaymentConstants';
import numberUtils from '../../../../utils/numberUtils';

import PaymentTracker from './PaymentTracker';

import { StyledHR } from './StyledComponents';
import { singleTextLineStyles } from '../../../../styles';
import type { PaymentsSummaryResponse } from '../../../../hooks/queries/summary/types';

const PaymentsCard = ({
  title,
  amount,
  description,
  firstName,
  lastName,
  paymentTracker,
  isLoading,
}: PaymentsSummaryResponse['paymentCardList'][number] & { isLoading: boolean }) => (
  <Spacer marginBottom="xs">
    <Card cardType="secondary" cardElevation={0} data-test="confirmation-payments-message-card">
      <Flex display="flex" justifyContent="space-between" alignItems="center" marginBottom={isLoading ? 'xxs' : null}>
        <LoadingParagraph textStyle="body-bold" loadingWidth="50%" isLoading={isLoading}>
          {title}
        </LoadingParagraph>
        <LoadingHeading level={5} loadingWidth="10%" isLoading={isLoading}>
          {numberUtils.asCurrency(amount / 100)}
        </LoadingHeading>
      </Flex>
      <LoadingParagraph textStyle="body-sm" loadingWidth="100%" isLoading={isLoading} css={{ paddingTop: '400' }}>
        {description}
      </LoadingParagraph>
      <LoadingParagraph
        textStyle="body-sm"
        isLoading={isLoading}
        loadingWidth="100%"
        css={singleTextLineStyles}
        className="fs-mask"
      >
        {firstName} {lastName}
      </LoadingParagraph>
      <StyledHR color="gray300" />
      {(paymentTracker || isLoading) && (
        // @ts-expect-error
        <PaymentTracker
          paymentType={PAYMENT_DESCRIPTION_TO_TYPE[description?.toLowerCase()] || ''}
          isLoading={isLoading}
          {...(paymentTracker || {
            paymentType: '',
            statusText: '',
            statusType: '',
            trackerStates: [],
          })}
        />
      )}
    </Card>
  </Spacer>
);

export default PaymentsCard;
